<template>
  <div v-if="isHeader">
    <span class="text-overflow text-clamp-2"
    v-tooltip="rowField.customField.label.toString().length > 24 ? rowField.customField.label : ''">{{ rowField.customField.label }}</span>
  </div>
  <div v-else-if="!isHeader">
    <input v-if="isEditable"
      class="input" type="text" v-model.trim="cfValue" @input="updateCfValue()" @blur="validateFields()" :placeholder="customField?.placeholder"
      :class="orderCf.hasError ? 'archived-border' : ''" v-tooltip="cfValue?.toString().length > 24 ? cfValue : ''"/>
    <span v-else>
      {{getVal()}}
    </span>
  </div>
</template>

<script>

import { onBeforeMount, reactive, toRefs, inject, computed } from 'vue';
import Validations from '../../utils/Validations';
import { cloneDeep, find, isEmpty, isFunction } from 'lodash';
import { useStore } from 'vuex';
import { screenLabelMap } from '@/components/mixins/UtilityMixin';

export default {
  name: 'String',
  props: {
    rowField: {
      type: Object,
      default: () => ({}),
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
    isEditing: {
      type: Boolean,
    },
    emitOrderSave: {
      type: Boolean,
      default: false,
    },
    isHeader: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const shippingEvents = inject('saveShipping');
    const store = useStore();
    const state = reactive({
      cfValue: '',
      customField: {},
      orderCf: {},
      oldCfValue: null,
    });

    onBeforeMount(() => {
      if (isEmpty(props.rowData.customFields) || !find(props.rowData.customFields, { _id: props.rowField.customField._id })) {
        if(!props.rowData.customFields) {
          props.rowData.customFields = [];
        }
        props.rowData.customFields.push(cloneDeep(props.rowField.customField));
      }
      state.customField = props.rowField.customField;  
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField && itemField.value) {
        state.cfValue = itemField.value;
        state.oldCfValue = state.cfValue;
      }
    });

    const updateCfValue = () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField) {
        itemField.value = state.cfValue;
      }
    };
    const tabType = () => {
      const screen = store.state.activeScreen === 'shipping-card-edit' ? 'deliveries-custom-fields' :
        ['detailing', 'manufacturing', 'qa'].includes(store.state.activeScreen) ? 'prod-custom-fields' : 'prod-items-custom-fields';
      return screenLabelMap[screen]?.tab || '';
    };
    const validateFields = async () => {
      let itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField) {
        itemField.__t = state.customField.__t;
        itemField.uniqueAcross = state.customField.uniqueAcross;
        itemField.label = state.customField.label;
        const isValid = await Validations.validateCustomFields(itemField, props.rowData, store.state.userData, false, tabType(),true);
        state.orderCf = itemField;
        state.cfValue = itemField.value;
        if (state.orderCf?.hasError || isValid === false) return;
        if (props.emitOrderSave && !isEmpty(shippingEvents) && isFunction(shippingEvents.save)) {
          if (state.oldCfValue !== itemField.value) {            
            await shippingEvents.save(props.rowData);
          }
        }
      }
    };

    const isEditable = computed(() => {
      if (props.rowField.isEditable) return true;
      if (props.rowField.noEdit) return false;
      return props.isEditing;
    })

    const getVal = () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField && itemField.value) {
        state.cfValue = itemField.value;
        return state.cfValue;
      }
      state.cfValue = '';
      return 'No text set'
    }

    return {
      ...toRefs(state),
      updateCfValue,
      validateFields,
      isEditable,
      getVal
    }
  }
}



</script>